import React from 'react';

import DatePicker from './DatePicker';

const DateOfBirthField = (props) => (
  <DatePicker {...props} placeholder="DD/MM/AAAA" />
);

export default DateOfBirthField;
